export const testUUID1 = '7caa71b0-86d2-4155-b871-8d84f98b71ee';
export const testUUID2 = 'ecb288da-97fd-415a-bb23-a488d8eba913';
export const testUUID3 = 'cb794cbe-ce47-4cfa-98c6-51b104947dbf';
